import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { IconContainer } from "../IconContainer.mjs";
import { IconMoneySvg } from "./IconMoneySvg.mjs";
const IconMoney = (props) => /* @__PURE__ */ jsx(IconContainer, { ...props, children: (svgProps) => /* @__PURE__ */ jsx(Box, { component: IconMoneySvg, ...svgProps }) });
export {
  IconMoney
};
